import { Component, OnInit } from '@angular/core'; 
import { AdminService } from '../../services/admin.service';
import { Router } from '@angular/router';
import { User } from '../../models/user';

@Component({
  selector: 'app-user-list',
  templateUrl: './admin-user-list.component.html'
})
export class AdminUserListComponent implements OnInit {
  adminUsers: User[] = [];
  searchedUsers: User[] = [];

  constructor(private user: AdminService, private router: Router) { }

  ngOnInit() {
    this.user.adminUsers().toPromise().then(result => {
      this.adminUsers = result;
    }).catch(error => {
      console.error('Error fetching admin users:', error);
    });
  }

  handleSearchResults(users: User[]): void {
    this.searchedUsers = users;
  }

  toggleUserAdminStatus(userId: string, isAdmin: boolean) {
    const action = isAdmin ? 'make this user a normal user' : 'make this user an admin';
    const alertMessage = `Are you sure you want to ${action}?`;
  
    if (!confirm(alertMessage)) {
      return;
    }
  
    const token = window.localStorage.getItem("auth_token");
    if (!token) {
      alert('You are not authenticated. Please log in again.');
      return;
    }
  
    this.user.toggleUserStatus(userId).toPromise()
      .then(() => {
        window.location.href = '/admin-users';
      })
      .catch(error => {
        if (error && error.error && error.error.error) {
          const errMsg = error.error.error.message || error.error.error.code;
          alert(errMsg);
        } else {
          console.error('Unexpected error:', error);
        }
      });
  }  
}